import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { JsonFormsDispatch, useJsonForms } from "@jsonforms/react";
import React from "react";

export const ReusableComponentRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("ReusableComponent")
);

function ReusableComponentRenderer({ uischema, schema, path }: RendererProps) {
  const id = uischema.options?.id;
  const { config, renderers, cells } = useJsonForms();
  const reusableComponents = config?.reusableComponents || [];

  const componentSchema = reusableComponents.find(
    (item: any) => item.id === id
  )?.content;

  if (componentSchema) {
    return (
      <JsonFormsDispatch
        renderers={renderers}
        cells={cells}
        uischema={componentSchema}
        schema={schema}
        path={path}
      />
    );
  }
  console.error(`No reusable component with id ${id} found`);
  return null;
}

export default ReusableComponentRenderer;
